import { html, el } from '../html.js';
import { screen } from '../shell.js';
import { api } from '../api.js';
import { state } from '../state.js';
import { go } from '../router.js';

export async function settingsView() {
  const s = screen({ back: true });
  s.body.append(el(html`<div class="stack">
    <h1>Settings</h1>
    <p class="signed-in">Signed in as ${state.user.username}</p>
    <ul class="rows">
      ${state.user.isOwner ? html`<li><a class="row-link" href="/invite">Invite and members</a></li>` : ''}
      <li><button class="row-link" type="button" data-sign-out>Sign out</button></li>
    </ul>
  </div>`));
  s.body.querySelector('[data-sign-out]').addEventListener('click', async () => {
    try {
      await api('POST', '/api/logout');
    } catch (x) {
      if (x.status !== 401) return s.status(x.message);
    }
    state.user = null;
    go('/', 'Signed out.');
  });
  return s.el;
}
